import { render, staticRenderFns } from "./acceptingTradeRequest.vue?vue&type=template&id=3d305513&scoped=true&"
import script from "./acceptingTradeRequest.vue?vue&type=script&lang=ts&"
export * from "./acceptingTradeRequest.vue?vue&type=script&lang=ts&"
import style0 from "./acceptingTradeRequest.vue?vue&type=style&index=0&id=3d305513&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d305513",
  null
  
)

export default component.exports